import { render } from "./LeaveTypesManagement.vue?vue&type=template&id=6f9add79&scoped=true"
import script from "./LeaveTypesManagement.vue?vue&type=script&lang=js"
export * from "./LeaveTypesManagement.vue?vue&type=script&lang=js"

import "./LeaveTypesManagement.vue?vue&type=style&index=0&id=6f9add79&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9add79"]])

export default __exports__